/* eslint-disable no-await-in-loop */
import { apiServiceNative } from '../../../utils/fetchNative';
import { ASSIGNABLE_STAFF_ROLE_IDS, CONSULTANT_ROLE_ID } from './constants';
import { unwrapCollection } from './utils';

const qs = require('qs');

export const fetchAssignableStaffUsers = async ({
  companyId,
  consultantOnly,
  allowedServiceId,
  roleId,
  fields = ['id', 'firstname', 'lastname'],
}: {
  companyId: number;
  consultantOnly: boolean;
  allowedServiceId?: number;
  roleId?: number;
  fields?: string[];
}) => {
  const roleFilter = roleId
    ? { $eq: roleId }
    : consultantOnly
    ? { $eq: CONSULTANT_ROLE_ID }
    : { $in: ASSIGNABLE_STAFF_ROLE_IDS };
  const params = qs.stringify(
    {
      filters: {
        company_user_role: {
          id: roleFilter,
        },
        company: { id: { $eq: companyId } },
        isActivated: { $eq: true },
        ...(allowedServiceId ? { allowed_services: { id: { $eq: allowedServiceId } } } : {}),
      },
      fields,
      populate: {
        allowed_services: { fields: ['id', 'name'] },
        company_user_role: { fields: ['id', 'name'] },
        category_tests: { fields: ['id'] },
      },
      sort: ['lastname:asc'],
    },
    { encodeValuesOnly: true }
  );
  const response = await apiServiceNative.get(`/api/users?${params}`);
  return unwrapCollection(response);
};
